import { useState } from "react";
import { toast } from "sonner";
import { chunkedUpload, uploadError } from "@/lib/chunkedUpload";

// uploads files one by one into a target; returns live progress and a busy count
export function useProofUploads(target, targetId, onFile) {
  const [items, setItems] = useState({});
  const upload = async (list) => {
    const keyed = Array.from(list).map((file) => [`${Date.now()}-${Math.random()}`, file]);
    setItems((p) => ({ ...p, ...Object.fromEntries(keyed.map(([k, f]) => [k, { name: f.name, p: 0, phase: "waiting" }])) }));
    for (const [key, file] of keyed) {
      try {
        const saved = await chunkedUpload({ target, targetId, file, onProgress: (p, phase) => setItems((s) => ({ ...s, [key]: { ...s[key], p, phase } })) });
        onFile(saved);
      } catch (err) {
        toast.error(`${file.name}: ${uploadError(err)}`);
      }
      setItems((s) => { const n = { ...s }; delete n[key]; return n; });
    }
  };
  return { items, upload, busy: Object.keys(items).length };
}

export function UploadProgress({ items }) {
  const list = Object.entries(items);
  if (!list.length) return null;
  return (
    <ul className="mt-4 flex flex-col gap-2" data-testid="upload-progress-list">
      {list.map(([key, it]) => (
        <li key={key} className="px-3 py-2 text-xs" style={{ border: "1px solid var(--border)", color: "var(--text-secondary)" }} data-testid="upload-progress-item">
          <div className="flex justify-between gap-3 mb-2">
            <span className="truncate">{it.name}</span>
            <span style={{ color: "var(--accent)" }} data-testid="upload-progress-label">{it.phase === "storing" ? "saving…" : `${Math.floor(it.p * 100)}%`}</span>
          </div>
          <div className="h-[3px] w-full" style={{ background: "var(--border)" }}>
            <div className={`h-full transition-[width] duration-300 ${it.phase === "storing" ? "animate-pulse" : ""}`} style={{ width: `${Math.max(2, it.p * 100)}%`, background: "var(--accent)" }} />
          </div>
        </li>
      ))}
    </ul>
  );
}
